import qs from 'qs';
import request from '@/config/request';

/*
  登录
*/
export function userLogin(username, password) {
  return request({
    url: '/login',
    method: 'get',
    params: {
      username,
      password,
    },
  });
}

/*
  退出
*/
export function userLogout() {
  return request({
    url: '/logout',
    method: 'get',
  });
}

/*
  修改密码，password
*/
export function updateAdminAccount(password) {
  return request({
    url: '/updateAdminAccount',
    method: 'post',
    data: qs.stringify({ password }),
  });
}
